import Menu from './menu'
import 'babylonjs-loaders';

window.addEventListener('DOMContentLoaded', async () => {
    // Create the game using the 'renderCanvas'.
    let menu = new Menu('renderCanvas');

    // Create the scene.
    await menu.createMenu();
});
